import { render, staticRenderFns } from "./PolicyLinks.vue?vue&type=template&id=2b9066bc&scoped=true&"
import script from "./PolicyLinks.vue?vue&type=script&lang=js&"
export * from "./PolicyLinks.vue?vue&type=script&lang=js&"
import style0 from "./PolicyLinks.vue?vue&type=style&index=0&id=2b9066bc&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9066bc",
  null
  
)

export default component.exports